import React from 'react';
import { bool, string, func, object } from 'prop-types';
import setClass from '../../common/set-class';
const Toggle = ({ onToggle, className, checked, isDisabled, disabled, style, value, }) => (React.createElement("div", { style: style, className: setClass([`b-toggle`, className]) },
    React.createElement("input", { type: "checkbox", name: "b-toggle-checkbox", value: value, checked: checked, disabled: isDisabled || disabled, onChange: (e) => onToggle && onToggle(e.target.checked) })));
Toggle.propTypes = {
    isDisabled: bool,
    disabled: bool,
    checked: bool,
    onToggle: func,
    style: object,
    className: string,
    value: string,
};
Toggle.defaultProps = {
    isDisabled: false,
    disabled: false,
    onToggle: null,
    style: {},
    className: '',
    checked: false,
    value: '',
};
export default Toggle;
